import React, { useState } from 'react'

function PreFooterBrief() {
  const budgetOptions = ['$<10k', '$10-25k', '$25-50k', '$50-100k', '$100k+']
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    budget: '$10-25k',
    message: ''
  })
  const [submitState, setSubmitState] = useState({ loading: false, message: '', isError: false })

  const handleChange = (event) => {
    const { id, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [id === 'brief-name' ? 'name' : id === 'brief-email' ? 'email' : 'message']: value
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const webhookUrl = process.env.REACT_APP_GOOGLE_SHEETS_WEB_APP_URL
    if (!webhookUrl) {
      setSubmitState({
        loading: false,
        isError: true,
        message: 'Form is not connected yet. Add REACT_APP_GOOGLE_SHEETS_WEB_APP_URL in .env.'
      })
      return
    }

    setSubmitState({ loading: true, message: '', isError: false })

    const payload = {
      ...formData,
      submittedAt: new Date().toISOString(),
      source: 'wfxlabs-website'
    }

    try {
      await fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: new URLSearchParams(payload).toString()
      })

      setSubmitState({
        loading: false,
        isError: false,
        message: 'Thanks. Your brief was submitted successfully.'
      })
      setFormData({
        name: '',
        email: '',
        budget: '$10-25k',
        message: ''
      })
    } catch (error) {
      setSubmitState({
        loading: false,
        isError: true,
        message: 'Submission failed. Please try again.'
      })
    }
  }

  return (
    <section id="project-brief" className="wfx-brief-section">
      <div className="wfx-brief-container">
        <div className="wfx-brief-grid">
          <div className="wfx-brief-left">
            <p className="sgrid-eyebrow">GET STARTED</p>
            <h2 className="wfx-brief-title">
              Let&apos;s talk about
              <br />
              <span>your project</span>.
            </h2>
            <p className="wfx-brief-copy">
              Tell us what you&apos;re building. We&apos;ll send back a written proposal in 48 hours
              fixed scope, fixed price, no fluff.
            </p>

            <div className="wfx-brief-contact-list">
              <div className="wfx-brief-contact-item">
                <span className="wfx-brief-contact-icon"><i className="bi bi-envelope"></i></span>
                <div>
                  <p>EMAIL</p>
                  <strong>hello@wfxlabs.org</strong>
                </div>
              </div>
              <div className="wfx-brief-contact-item">
                <span className="wfx-brief-contact-icon"><i className="bi bi-telephone"></i></span>
                <div>
                  <p>SRI LANKA</p>
                  <strong>+94 76 7174 075</strong>
                </div>
              </div>
              <div className="wfx-brief-contact-item">
                <span className="wfx-brief-contact-icon"><i className="bi bi-telephone"></i></span>
                <div>
                  <p>UAE</p>
                  <strong>+971 58 229 5491</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="wfx-brief-card">
            <form onSubmit={handleSubmit}>
              <label htmlFor="brief-name">Your Name</label>
              <input
                id="brief-name"
                type="text"
                placeholder="Jane Cooper"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label htmlFor="brief-email">Work Email</label>
              <input
                id="brief-email"
                type="email"
                placeholder="jane@company.com"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label>Budget</label>
              <div className="wfx-brief-budget">
                {budgetOptions.map((budget) => (
                  <button
                    key={budget}
                    type="button"
                    className={formData.budget === budget ? 'is-active' : ''}
                    onClick={() => setFormData((prev) => ({ ...prev, budget }))}
                  >
                    {budget}
                  </button>
                ))}
              </div>

              <label htmlFor="brief-message">What Are You Building?</label>
              <textarea
                id="brief-message"
                rows="4"
                placeholder="A few sentences about the product, timeline, and what success looks like."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit" className="wfx-brief-submit" disabled={submitState.loading}>
                {submitState.loading ? 'Submitting...' : 'Send brief'}
                <i className="bi bi-arrow-right ms-2"></i>
              </button>
              <p className={`wfx-brief-note ${submitState.message ? (submitState.isError ? 'is-error' : 'is-success') : ''}`}>
                {submitState.message || ''}
              </p>
              <p className="wfx-brief-note">
                We reply within one business day. No newsletters, no spam  we promise.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PreFooterBrief
